module.exports = __webpack_public_path__ + "static/img/logo.96310ae.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/baseImg/logo.png
// module id = eSir
// module chunks = 1